import t from "@nightingale-elements/nightingale-new-core";
function e(t, e, i, r) {
  var s,
    l = arguments.length,
    n = l < 3 ? e : null === r ? r = Object.getOwnPropertyDescriptor(e, i) : r;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, i, r);else for (var a = t.length - 1; a >= 0; a--) (s = t[a]) && (n = (l < 3 ? s(n) : l > 3 ? s(e, i, n) : s(e, i)) || n);
  return l > 3 && n && Object.defineProperty(e, i, n), n;
}
"function" == typeof SuppressedError && SuppressedError;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i = (t, e) => "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
  ...e,
  finisher(i) {
    i.createProperty(e.key, t);
  }
} : {
  kind: "field",
  key: Symbol(),
  placement: "own",
  descriptor: {},
  originalKey: e.key,
  initializer() {
    "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
  },
  finisher(i) {
    i.createProperty(e.key, t);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r(t) {
  return (e, r) => void 0 !== r ? ((t, e, i) => {
    e.constructor.createProperty(i, t);
  })(t, e, r) : i(t, e);
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
}
function s(t) {
  return r({
    ...t,
    state: !0
  });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l, n;
null === (l = window.HTMLSlotElement) || void 0 === l || l.prototype.assignedElements;
let a = n = class extends t {
  constructor() {
    super(...arguments), this["reflected-attributes"] = new Map(), this.protvistaElements = new Set(), this.propertyValues = new Map();
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("change", this.changeListener), this.style.display = "unset";
  }
  attributeChangedCallback(t, e, i) {
    super.attributeChangedCallback(t, e, i), this.applyAttributes();
  }
  applyAttributes() {
    this.protvistaElements.forEach(t => {
      var e;
      null === (e = this["reflected-attributes"]) || void 0 === e || e.forEach((e, i) => {
        !1 === e || null == e ? t.removeAttribute(i) : t.setAttribute(i, "boolean" == typeof e ? "" : e);
      }), this.length && t.setAttribute("length", `${this.length}`), this["display-end"] && t.setAttribute("display-end", `${this["display-end"]}`), this["display-start"] && t.setAttribute("display-start", `${this["display-start"]}`), this.highlight && t.setAttribute("highlight", this.highlight);
    });
  }
  register(t) {
    this.protvistaElements.add(t), this.applyAttributes();
  }
  unregister(t) {
    this.protvistaElements.delete(t);
  }
  applyProperties(t) {
    if (t) {
      const e = this.querySelector(`#${t}`);
      if (!e) return;
      this.propertyValues.forEach((t, i) => {
        e[i] = t;
      });
    } else this.protvistaElements.forEach(t => {
      t && this.propertyValues.forEach((e, i) => {
        t[i] = e;
      });
    });
  }
  isRegisteredAttribute(t) {
    return !!this["reflected-attributes"] && ([...this["reflected-attributes"].keys()].includes(t) || n.observedAttributes.includes(t));
  }
  changeListener(t) {
    var e;
    if (t.detail) if ("property" === t.detail.handler) this.propertyValues.set(t.detail.type, t.detail.value), this.applyProperties(t.detail.for);else this.isRegisteredAttribute(t.detail.type) && (null === (e = this["reflected-attributes"]) || void 0 === e || e.set(t.detail.type, t.detail.value)), Object.keys(t.detail).forEach(e => {
      var i;
      this.isRegisteredAttribute(e) && (null === (i = this["reflected-attributes"]) || void 0 === i || i.set(e, t.detail[e]));
    }), this.applyAttributes();
  }
};
e([r({
  converter: {
    fromAttribute: t => {
      if (!t) return null;
      const e = t.split(",");
      if (-1 !== e.indexOf("type")) throw new Error("'type' can't be used as a protvista attribute");
      if (-1 !== e.indexOf("value")) throw new Error("'value' can't be used as a protvista attribute");
      return new Map(e.filter(t => !n.observedAttributes.includes(t)).map(t => [t, null]));
    },
    toAttribute: t => t.join(",")
  }
})], a.prototype, "reflected-attributes", void 0), e([r({
  type: Number
})], a.prototype, "length", void 0), e([r({
  type: Number
})], a.prototype, "display-start", void 0), e([r({
  type: Number
})], a.prototype, "display-end", void 0), e([r({
  type: String
})], a.prototype, "highlight", void 0), e([s()], a.prototype, "protvistaElements", void 0), e([s()], a.prototype, "propertyValues", void 0), a = n = e([(t => e => "function" == typeof e ? ((t, e) => (customElements.define(t, e), e))(t, e) : ((t, e) => {
  const {
    kind: i,
    elements: r
  } = e;
  return {
    kind: i,
    elements: r,
    finisher(e) {
      customElements.define(t, e);
    }
  };
})(t, e))("nightingale-manager")], a);
var o = a;
export { o as default };
